/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

import { Box, FormControl } from "@mui/material";
import { TextField } from "@mui/material";
import { getIn } from "formik";

import { InfoTitle, InputMessage, ContextualHelp } from "../index";

interface IProps {
  placement: string;
  disabled: boolean;
  placeholder: string;
  label: string;
  field: {
    name: string;
    value: string;
  };
  shrink: boolean | undefined;
  infoTitle: string;
  form: {
    errors: {
      optionalObject: Record<string, any>;
    };
  };
  onFocus: (a: any) => void;
  onBlur: (a: any) => void;
  contextualHelpText: string;
  contextualHelpProps: Record<string, any>;
  errorContainerClassName?: string;
  multiline?: boolean;
  variant?: "filled" | "standard" | "outlined";
  size?: "small" | "medium";
  waringMessage?: string;
}

const Input = ({
  placement,
  disabled,
  placeholder,
  label,
  field,
  shrink,
  infoTitle,
  form: { errors },
  onFocus,
  onBlur,
  contextualHelpText,
  contextualHelpProps,
  errorContainerClassName,
  waringMessage,
  ...props
}: IProps): React.ReactElement => {
  const errorMessage = getIn(errors, field.name);

  return (
    <FormControl sx={{ width: "100%" }}>
      <ContextualHelp title={contextualHelpText} {...contextualHelpProps}>
        <TextField
          {...field}
          {...props}
          value={field.value === null || field.value === undefined ? "" : field.value}
          label={label}
          placeholder={placeholder}
          disabled={disabled}
          error={!!errorMessage}
          onFocus={(event) => {
            onFocus && onFocus(event);
          }}
          onBlur={(event) => {
            onBlur && onBlur(event);
          }}
          data-test="base-input"
          {...(waringMessage && { color: "warning" })}
        />
      </ContextualHelp>

      <Box
        position="absolute"
        top="55px"
        left={0}
        sx={{
          ...(props.variant === "standard" && { top: "48px" }),
          ...(props.size === "small" && { top: "40px" }),
          ...(props.multiline && { bottom: "-14px", top: "initial" }),
        }}
      >
        {(errorMessage || waringMessage) && (
          <InputMessage warning={waringMessage} error={errorMessage} />
        )}
      </Box>

      {infoTitle && <InfoTitle title={infoTitle} />}
    </FormControl>
  );
};

export default Input;
